import React, { useEffect, useState } from 'react'; 
import Popup from '../components/CusPopup';
import { Button } from '@progress/kendo-react-buttons';
import { FormComboBox, FormNumericTextBox } from '../validation/Form-Components';
import { decimalValidator,   reqDDLValidator, zeroDecimalValidator } from '../validation/Validators';
import { Field } from '@progress/kendo-react-form';
import { MdClose } from "react-icons/md";
import styled from "styled-components";
import helper from '../factory/Helper';
import pData from '../hybriddata/propertydata.json';
import {  Error  } from '@progress/kendo-react-labels';

const AddCommitmentPopup = (props) => {

    const CloseModalButton = styled(MdClose)`
    color: white;
    cursor: pointer;
    position: absolute;
    top: 10px;
    right: 10px;
    width: 32px;
    height: 32px;
    //padding: 0;
    // z-index: 10;
    //top: 16px;
  `;

    const { editedItem,fProps }= props;

    const[isFormEdited,setIsFormEdited] = useState(false);

    const [selectedProdType,setSelectedProdType] = useState(null);

    const [showErrMsg,setShowErrMsg] = useState(false);
    const [errMsg, setErrMsg] = useState('');

    useEffect(() => {
        console.log('@AddCommitmentPopup useEffect');
 
        let prodType={}, noOfBank={},amt=null;

        if(editedItem !== null) {
            setIsFormEdited(true);
     
            prodType = editedItem.ddlLoanProdType;
            noOfBank = editedItem.ddlNoOfBank;
            amt = parseFloat(editedItem.amount);
            setSelectedProdType(prodType);
        }

        fProps.onChange('ProductType', { value: prodType});
        fProps.onChange('NoOfBanks', { value: noOfBank});
        fProps.onChange('amount', { value: amt});

 
    }, []);
    
    const handleSetTrigger = () => {
        props.setTrigger();
    }

    const handleProceed = (dataItem) => {
        const params = formatJsonParams();
 
        props.onClickAdd(params,isFormEdited);
    }

    const formatJsonParams = () => {
        const ddlProdType = fProps.valueGetter("ProductType");
        const ddlNoOfBanks = fProps.valueGetter("NoOfBanks");
        const amtValue = fProps.valueGetter("amount");

 
        const commitmentDetails = {
            ddlLoanProdType:ddlProdType,
            ddlNoOfBank: ddlNoOfBanks,
            amount: amtValue.toFixed(2)
        }
        return commitmentDetails;
    }

    const disabledBtnAdd = ()=>{
        let result = false;
        const ddlProdType = fProps.valueGetter("ProductType");
        const ddlNoOfBanks = fProps.valueGetter("NoOfBanks");
        const amtValue = fProps.valueGetter("amount");
 
        if(ddlProdType === null || ddlNoOfBanks === null || amtValue === null || amtValue === 0) {
            result = true;
        }
        else if(helper.isEmptyObj(ddlProdType) || helper.isEmptyObj(ddlNoOfBanks)) {
            result = true;
        }
   
        return result;
    }

    const handleProductTypeOnChange = (e) => {
        setSelectedProdType(e.value);
    }

    const handleAmountChange = (e) => {
    //    console.log('handleAmountChange: ',e);
       const amtValue = e.value;
       if(amtValue) {
            if(amtValue <=0) {
                setShowErrMsg(true);
                setErrMsg('Input should be more than 0.00');
            }
            else {
                setShowErrMsg(false);
                setErrMsg('');
            }
       }
       else {
        if(amtValue <=0) {
            setShowErrMsg(true);
            setErrMsg('Input should be more than 0.00');
        }
        else {
            setShowErrMsg(true);
            setErrMsg('Input numeric characters');
        }
       }
    }

    return props.popupValue && (
        <div className="popup">
        <div className="aip-popup-inner">
            <CloseModalButton
                aria-label="Close modal"
                onClick={() => props.setTrigger(false)}
            />
            <div className="fbaPSize">
                <div className="bgBlackYellowBorder">
                    <div className="row around-xs inputPair">
                        <div className="col-11">
                            <div className="dcPgmh">{'Add Commitment Details'}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div style={{paddingTop:'10px'}}>
                <div className='row around-xs inputPair'>
                    <div className="col-12">
                        <div className='box'>{'Product Type'}</div>
                        <Field id={'ProductType'} 
                            name={'ProductType'}
                            component={FormComboBox}
                            textField={'label'}
                            data={pData.loanProdTypeDDLList}
                            placeholder={'Select Product Type'}
                            validator={reqDDLValidator}
                            onChange={handleProductTypeOnChange}
                        />
                    </div>
                </div>

                <div className='row around-xs inputPair'>
                    <div className="col-12">
                        <div className='box'>{'No. of Banks'}</div>
                        <Field id={'NoOfBanks'} 
                            name={'NoOfBanks'}
                            component={FormComboBox}
                            textField={'label'}
                            data={pData.noOfBanksDDLList}
                            placeholder={'Select No. of Banks'}
                            disabled={selectedProdType ===null?true:false}
                            validator={reqDDLValidator}
                        />
                    </div>
                </div>

                <div className='row around-xs inputPair'>
                    <div className="col-12">
                        <div className='box'>{'Amount'} </div>
                        <Field component={FormNumericTextBox}
                            id={'amount'}
                            name={'amount'}
                            placeholder={'S$0'}
                            min={0}
                            spinners={false} 
                            disabled={selectedProdType ===null?true:false}
                            format="c2"
                            onChange={handleAmountChange}
                        />
                        {showErrMsg && <Error id={'error1'}>{errMsg}</Error>}
                        {(selectedProdType !== null) &&
                        <div className='txtGray'>
                            {selectedProdType.value === pData.overDraftCode?'Please key in facility limit':'Please key in monthly instalment'}
                        </div>
                        }   
                    </div>
                </div>
            </div>
            <div style={{paddingTop:'10px'}}>
                <div className='popupbtn'>
                    <Button className="k-button btn btn-success" 
                        disabled={disabledBtnAdd()}
                        onClick={handleProceed}>{'ADD'}</Button> 
                </div>
            </div>
        </div>
        </div>
    )
}

export default AddCommitmentPopup;